function requireEnv(value, key) {
    const normalized = String(value ?? '').trim()
    if (!normalized) {
        throw new Error(`Missing required environment variable: ${key}`)
    }
    return normalized
}

function requireCode(value, key) {
    const normalized = requireEnv(value, key)
    if (!/^[a-z0-9_-]+$/i.test(normalized)) {
        throw new Error(`${key} may only contain letters, numbers, underscores and hyphens`)
    }
    return normalized
}

function trimTrailingSlash(value) {
    return value.replace(/\/+$/, '')
}

function getBackendBaseUrl() {
    const configuredBaseUrl = String(process.env.VUE_APP_BACKEND_BASE_URL ?? '').trim()
    if (configuredBaseUrl) {
        return trimTrailingSlash(configuredBaseUrl)
    }

    const legacyBackendUrl = requireEnv(process.env.VUE_APP_BACKEND_URL, 'VUE_APP_BACKEND_URL')
    const normalizedUrl = /^https?:\/\//i.test(legacyBackendUrl)
        ? legacyBackendUrl
        : `http://${legacyBackendUrl}`
    return trimTrailingSlash(normalizedUrl)
}

const collegeCode = requireCode(process.env.VUE_APP_COLLEGE_CODE, 'VUE_APP_COLLEGE_CODE')
const collegeBasePath = `/${collegeCode}`
const configuredDefaultTemplate = String(process.env.VUE_APP_DEFAULT_TEMPLATE || '').trim().toUpperCase()
const universityCode = requireCode(process.env.VUE_APP_UNIVERSITY_CODE, 'VUE_APP_UNIVERSITY_CODE')
const universityName = requireEnv(process.env.VUE_APP_UNIVERSITY_NAME, 'VUE_APP_UNIVERSITY_NAME')
const collegeName = requireEnv(process.env.VUE_APP_COLLEGE_NAME, 'VUE_APP_COLLEGE_NAME')
const defaultTemplate = ['A', 'B', 'C'].includes(configuredDefaultTemplate)
    ? configuredDefaultTemplate
    : 'A'

// HTTP header values only use ASCII. The backend decodes these values and
// creates the single school/college records when the database is empty.
const tenantHeaders = Object.freeze({
    'X-Tenant-University-Code': universityCode,
    'X-Tenant-University-Name': encodeURIComponent(universityName),
    'X-Tenant-College-Code': collegeCode,
    'X-Tenant-College-Name': encodeURIComponent(collegeName),
    'X-Tenant-Default-Template': defaultTemplate,
})

const siteConfig = Object.freeze({
    universityCode,
    universityName,
    universityUrl: requireEnv(process.env.VUE_APP_UNIVERSITY_URL, 'VUE_APP_UNIVERSITY_URL'),
    collegeCode,
    collegeName,
    collegeUrl: requireEnv(process.env.VUE_APP_COLLEGE_URL, 'VUE_APP_COLLEGE_URL'),
    collegeBasePath,
    peoplePath: `${collegeBasePath}/people`,
    profilePath: `${collegeBasePath}/profile`,
    backendBaseUrl: getBackendBaseUrl(),
    imageBaseUrl: trimTrailingSlash(requireEnv(process.env.VUE_APP_IMAGE_BASE_URL, 'VUE_APP_IMAGE_BASE_URL')),
    scholatBaseUrl: trimTrailingSlash(requireEnv(process.env.VUE_APP_SCHOLAT_BASE_URL, 'VUE_APP_SCHOLAT_BASE_URL')),
    scholatAcademicBase: trimTrailingSlash(requireEnv(process.env.VUE_APP_SCHOLAT_ACADEMIC_BASE, 'VUE_APP_SCHOLAT_ACADEMIC_BASE')),
    scholatProfileSyncUrl: requireEnv(process.env.VUE_APP_SCHOLAT_PROFILE_SYNC_URL, 'VUE_APP_SCHOLAT_PROFILE_SYNC_URL'),
    adminLoginUrl: requireEnv(process.env.VUE_APP_ADMIN_LOGIN_URL, 'VUE_APP_ADMIN_LOGIN_URL'),
    defaultTemplate,
    tenantHeaders,
})

export default siteConfig
